import { NavController, NavParams, ModalController } from 'ionic-angular';
import {Component, ViewChild} from '@angular/core';
import {ToastController,AlertController} from 'ionic-angular';
import { Headers , RequestOptions } from '@angular/http';
import {SearchCustomersPage} from "../search-customers/search-customers";
import {CartPage} from '../cart/cart';
import {CartManager} from "../../providers/cart-manager";
import {ItemsPage} from '../items/items';
import {Api} from '../../providers/api';
import {IMAGES_BASE_URL,Constants,ApplicationVariables } from '../../providers/config';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage';
import {Printer, PrintOptions, Push} from 'ionic-native';
import { MsgManager } from '../../providers/msg-manager';
import { ThankYouModalPage } from '../thank-you-modal/thank-you-modal';
import { GVLogger } from '../../services/gv-logger';
import { PickPackParamsPage } from '../pickpackparams/pickpackparams';
import { CART } from '../../providers/data';
import { shipmentCART } from '../../providers/data';
import { customFieldsProvider } from '../../providers/params';
import { LicenseStatusModelPage } from '../license-status-model/license-status-model';
import { ProductLocationsModelPage } from '../product-locations-model/product-locations-model';
import {ConfirmShipmentPage} from "../confirm-shipment/confirm-shipment";
import {ShipmentcartManagerProvider} from "../../providers/shipmentcart-manager";
import {ItemPage} from "../item-details/item-details";
import {ShipmentReadyPage} from "../shipment-ready/shipment-ready";
import {LoginPage} from "../login/login";


@Component({
  selector: 'page-shipmentslist',
  templateUrl: 'shipmentslist.html',
})
export class ShipmentslistPage {

  // baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;

  // isOfflineMode:any;

  // salesPerson;

  // currentDate;
  // placeOrderButton = true;

  // attributesPropertiesMap:any = new Map();
  // shipto = '';
  // constants = Constants;

  // space: string = ", ";
  // spaceAddress1 : string;
  // spaceAddress2 : string;
  // public shipToVal : any = "shipto";
  // BOLVariables = [];
  // lengthTotalizer = 0;

  // adpCustomerInfo :any ={};

  // public cart: any;
  // public TotalPrice: number = 0;
  // public TotalPriceBeforeTax: number = 0;
  // public taxPercent = 0; // Changed from 0.13
  // public taxAmount = 0;
  // public locationSelected: any;
  // public locationSelectedObject: any;
  // public expectedShipmentDate: any = "";
  // public orderMessage = "";
  // spaceCity: string;
  // spaceState: string;
  // spaceCountry: string;
  // deoded: string;
  // TAX: number = 0;
  order: any;
  // selectFirstBillTo: any;
  // pickPackParamsVariables: any;
  // SoldToCompany;
  // SoldToAddress;
  // lengthTotalizerr: string;
  // lengthTotalizerDecimalFix: string;
  // shipOrderButton = true;
  // downloadCSVButtonStatus = true;
  // private shipmentCart: any;
  // private qty = 0;
  private shipmentsData= [];
  private shipmentsAvailabilityCheck: boolean = false;
  private shipmentsLength = 0;
  // @ViewChild('barcodeFocusOnProductScan') barcodeFocusOnProductScan;
  // private regularProductsAvailCheck: boolean = false;
  // private allProdAvailCheck = false;
  // arr = ["W1Z2A1S3B1", "mango", "banana", "sugar"];
  // private totalQtyOfSelectedProducts = 0;
  // private totalQtyOrdered = 0;
  // private quantityRemainingInPickPack = 0;
  // private pageStatus = "";
  // private orderStatus: any = 0;
  productLocationDisplayStatus: boolean = true;
  // pickLocationButtonStatus = false;

  constructor(public nav: NavController,
   private cartManager:CartManager,
   private api:Api,public storage: Storage,
    public toastCtrl: ToastController,
    public params:NavParams,
     public alertCtrl: AlertController,
     public msgManager:MsgManager,
     private gVLogger:GVLogger,
     private modalCtrl:ModalController,
     public paramsProvider : customFieldsProvider,
     private shipmentCartManager:ShipmentcartManagerProvider) {

      // this.cart = this.params.get("cart");
      this.order = this.params.get("orderView");
      // this.orderStatus = this.cart.orderStatus;
      // this.gVLogger.log("OrderStatus : " + this.orderStatus);
    this.shipments();
  }
  shipments(){
    this.gVLogger.log("shipments calledddddddd : ");
    var url = "/order/loadShipmentsByOrder";
    var body = "?searchString="+this.order.id;
    var shipmentAvail = false;
    this.api.post(url+body,null).map(res => res.json()).subscribe(data => {
      this.gVLogger.log("data from /products/getProductsForPickShip : " + data);
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }
      if(data.status === "200") {

        for(let index of data.data) {
          this.gVLogger.log("index for loop in shipments + " + JSON.stringify(index.shipmentNoticeByNoticesId.shipmentNo))
          if (this.shipmentsData.length > 0) {
            shipmentAvail = false;
          for (let shipments of this.shipmentsData) {
            this.gVLogger.log("shipments for loop in shipments + " + JSON.stringify(shipments.shipmentNoticeByNoticesId.shipmentNo))

            if (shipments.shipmentNoticeByNoticesId.shipmentNo === index.shipmentNoticeByNoticesId.shipmentNo) {
              shipmentAvail = true;
            }
          }
        }
          this.gVLogger.log("shipment avail status : " + shipmentAvail);
          if(!shipmentAvail){
            this.shipmentsData.push(index);
          }
        }
        // this.shipmentsData = data.data;
        this.shipmentsLength =  this.shipmentsData.length;
        this.gVLogger.log("shipment length in pick pack list page : " + this.shipmentsLength);
        if(data.data.length > 0){

          this.shipmentsAvailabilityCheck = false;
        }
        else {
          this.shipmentsAvailabilityCheck = true;
        }
      }
      else {
        this.shipmentsData = [];
        this.shipmentsAvailabilityCheck = true;
      }
    });
  }

  shipmentDetails(shipment){

    if(this.productLocationDisplayStatus){
      this.productLocationDisplayStatus = false;

    this.gVLogger.log("tap called...");
    var url = "/order/loadShipment";
    var body = "?orderId="+this.order.id+"&shipmentId="+shipment.shipmentNoticeByNoticesId.id;
    this.api.post(url+body,null).map(res => res.json()).subscribe(data => {
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }
      if(data.status === "200") {
        let orderPickPackList = this.order;
        let orderView = orderPickPackList;


        let productsList: any = [];
        let productsListForShipment: any = [];
        for(let orderDetail of data.data.orderDetailShipmentDTOS){
          let product: any = orderDetail.productsDTO;
          productsList.push(product);
        }
        let cart:any = {};

        this.gVLogger.log(orderPickPackList);

        cart.customer = orderPickPackList.customerDTO;
        cart.orderMessage = orderPickPackList.orderMessage;
        cart.expectedShipmentDate = orderPickPackList.expectedShipmentDate;
        cart.shippingServiceName = orderPickPackList.shippingServiceName;
        cart.shippingServiceId = orderPickPackList.shippingServiceValue;
        cart.orderId = orderPickPackList.id;
        cart.shipmentId = shipment.shipmentNoticeByNoticesId.id;
        cart.shipmentNoticeStatus = shipment.shipmentNoticeByNoticesId.status;
        cart.items = productsList;
        // cart.items = this.shipmentCartManager.getItems();
        cart.orderStatus = orderPickPackList.orderStatus;
        cart.customerOrderNumber = data.data.customerOrderNumber;
        cart.orderTitle = orderPickPackList.orderTitle;
        cart.shippingServiceValue = data.data.shippingServiceValue
        cart.shippingServiceName = data.data.shippingServiceName
        cart.customerId = data.data.customerId
        cart.trackingCode = data.data.shipmentNoticesDTO.trackingCode
        cart.shipmentShippingService = data.data.shipmentNoticesDTO.shippingService

        // alert(cart.shipmentShippingService)
        this.nav.push(ConfirmShipmentPage,{"cart":cart,"TotalPrice":orderPickPackList.totalAmount, "orderView" : orderView, "pageStatus" : "shipment", "plannedShipmentDate" : data.data.plannedShipmentDate, "shipmentNo" : shipment.shipmentNoticeByNoticesId.shipmentNo, "shipmentId" : shipment.shipmentNoticeByNoticesId.id});
      }
      else {
        this.gVLogger.log("else calledd with shipmentDetails ");
      }
    });
    setTimeout(() => {
        this.productLocationDisplayStatus = true;
    },1000)
  }
}

  ngOnDestroy(){
  let prodPickedStatus = 0;
  let itemCountForOneOfItsKind = 0;
  let oneOfItsKindAvailCheck = false;
    for(let product of this.shipmentCartManager.getItems()){
      if(product.productType === 1){
        itemCountForOneOfItsKind += 1;
      }
        for(let qtyPicked of product.productInventoryLocationsDTO){
          if(qtyPicked.status === 1){
            prodPickedStatus = 1;
            break;
          }
        }
    }

    if(this.shipmentCartManager.getItems().length === itemCountForOneOfItsKind){
      oneOfItsKindAvailCheck = true;
    }
    if(this.shipmentCartManager.getItems().length > 0 && prodPickedStatus === 1 && oneOfItsKindAvailCheck === false){
      let confirm = this.alertCtrl.create({
        title: 'Unsaved cart found.',
        message: "What would you like to do?",
        buttons: [
          {
            text: 'Go to old cart',
            handler: () => {
              let orderView = this.order;

              this.gVLogger.log("orrrdddeeeerrrr before before adding in shipment cart manager : " + JSON.stringify(this.order));

              let productsList: any = [];
              for(let orderDetail of this.order.orderDetailDTOs){
                let product: any = orderDetail.productsDTO;
                productsList.push(product);
                this.shipmentCartManager.addProductToCart(product);
              }

              for(let ship of this.shipmentCartManager.getItems()){   // UD code in server down
                if(ship.productType === 1){
                  ship.productInventoryLocationsDTO[0].quantityReceived = ship.quantity;
                  ship.productInventoryLocationsDTO[0].status = 1;
                }
              }



              let cart:any = {};

              this.gVLogger.log(this.order);

              cart.customer = this.order.customerDTO;
              cart.orderMessage = this.order.orderMessage;
              cart.expectedShipmentDate = this.order.expectedShipmentDate;
              cart.shippingServiceName = this.order.shippingServiceName;
              cart.shippingServiceId = this.order.shippingServiceValue;
              cart.orderId = this.order.id;
              // cart.items = productsList;
              cart.items = this.shipmentCartManager.getItems();
              cart.orderStatus = this.order.orderStatus;
              cart.orderTitle = this.order.orderTitle;

              // this.gVLogger.log(JSON.stringify(cart));
              this.storage.set("orderInStorage", this.order);
              if(Constants.isWebstore){
                this.nav.push(ShipmentslistPage,{"cart":cart,"TotalPrice":this.order.totalAmount, "orderView" : orderView})
              }else{
                this.nav.push(ShipmentslistPage,{"cart":cart,"TotalPrice":this.order.totalAmount, "orderView" : orderView});

              }
            }
          },
          {
            text: 'Replace with new cart',
            handler: () => {
              this.shipmentCartManager.clearCart();

            }
          }
        ]
      });
      confirm.present();
    }
    else {
      this.shipmentCartManager.clearCart();
    }

      }
//
//
//   onFocusBarcode(event){
//     event.target.value = "";
//   }
//   onBlurBarcode(event){
//     event.target.value = "";
//   }
//
//   viewItem(item) {
//
//     this.api.get("product/" + item.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
//       if(data.status === "200"){
//         item.description = data.data.description;
//       }
//     })
//     this.nav.push(ItemPage, {item: item})
//   }


  mergeShipments(){
    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: "You want to merge all ship ready shipments. This can't be undone.",
      buttons: [
        {
          text: 'Cancel',
          handler: () => {

          }
        },
        {
          text: 'Merge',
          handler: () => {
            this.api.get("shipmentNotice/mergeShipmentNotices?orderId="+this.order.id).map(res => res.json()).subscribe(data => {
              if(data.status == "401"){ // check for session out
                this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                this.nav.setRoot(LoginPage);
              }
              if(data.status === "200"){
                this.api.toastMSG("Shipments merged successfully.");
                // setTimeout(() => {
                this.shipmentsData = [];
                  this.shipments();
                // },1000)

              }
            })
          }
        }
      ]
    });
    confirm.present();



  }

  getDisableStatus(){
    let shipReadyShipments = 0
    for(let shipment of this.shipmentsData){
      if(shipment.shipmentNoticeByNoticesId.status === 5){
        shipReadyShipments++
      }
    }

    if(shipReadyShipments > 1)
      return false
    else
      return true
  }

}



// WEBPACK FOOTER //
// ./src/pages/shipmentslist/shipmentslist.ts